import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { AppCard } from "@/shared/Components";
import { FormButtonSelect } from "@/shared/Components/Form/FormButtonSelect";
import { currentPersonSelector } from "@/pages/ContactsPage/slice";
import { useAppSelector } from "@/services/store";
import type { PersonInfoCardProps } from "../types";
import { Edit } from "../Edit";
import { View } from "../View";
import { PersonAvatar } from "../Components/PersonAvatar";
import styles from "./styles.module.scss";

export const PersonInfoCardDesktop: React.FC<PersonInfoCardProps> = ({
  content,
  className,
  isEdit,
  avatarIsEditable,
}) => {
  const { t } = useTranslation();
  const currentPerson = useAppSelector(currentPersonSelector);

  return (
    <AppCard key={content.id} className={classNames(styles.card, className)}>
      <div className={styles["card-content"]}>
        <div className={styles["card-inner"]}>
          {currentPerson && <PersonAvatar isEditable={avatarIsEditable} person={currentPerson} />}
          {isEdit && (
            <FormButtonSelect
              placeholder={t("contactsPage.group")}
              name="group"
              options={[
                { label: t("contactsPage.groups.other"), value: "Other" },
                { label: t("contactsPage.groups.business"), value: "Business" },
                { label: t("contactsPage.groups.friends"), value: "Friends" },
                { label: t("contactsPage.groups.colleagues"), value: "Colleagues" },
                { label: t("contactsPage.groups.family"), value: "Family" },
              ]}
            />
          )}
        </div>
        {isEdit ? <Edit /> : <View content={content} layout="desktop" />}
      </div>
    </AppCard>
  );
};
